import { AssetTypesPascalCaseSingular } from '@api/v4/assets/assetTypes';
import { createCustomFieldValues } from '@api/v4/custom_fields/custom-field-keys';
import { CustomFieldKeysResponseObject } from '@api/v4/resources/CustomFieldKeysTypes';
import { CustomFieldValuesListResponse } from '@api/v4/assets/customFieldTypes';
import {
  CustomFieldKeyValuesEntry,
  FlattenedCustomFieldKeyValuesMap
} from '@components/asset/modal/tabs/edit/EditTabTypes';

export const isMissingCustomFieldValue = (customFieldsMapEntry: CustomFieldKeyValuesEntry): boolean => (
  !customFieldsMapEntry?.customFieldValues?.length || !customFieldsMapEntry.customFieldValues[0].value
);

export const putCustomFields = (
  requiredCustomFieldKeys: CustomFieldKeysResponseObject[],
  customFieldsMap: FlattenedCustomFieldKeyValuesMap,
  assetKeys: string[]
): Promise<CustomFieldValuesListResponse>[] => {
  const customFieldPromises: Promise<CustomFieldValuesListResponse>[] = []; // type
  requiredCustomFieldKeys.forEach((requiredKey) => {
    const values: { value: string; assetKey: string }[] = [];
    customFieldsMap[requiredKey.id].customFieldValues.forEach((customFieldValue) => {
      assetKeys.forEach((assetKey) => {
        values.push({ value: customFieldValue.value, assetKey });
      });
    });
    customFieldPromises.push(createCustomFieldValues(values, requiredKey.id));
  });
  return customFieldPromises;
};

/**
 * Get whether there are any required custom field keys for an asset that's a GenericFile
 * @param requiredCustomFieldKeys CustomFieldKeysResponseObject[] | null
 * @param assetType string
 * @returns boolean
 */
export const getHasRequiredCustomFields = (
  requiredCustomFieldKeys: CustomFieldKeysResponseObject[] | null,
  assetType: string
): boolean => !!requiredCustomFieldKeys
  && requiredCustomFieldKeys.length > 0
  && assetType === AssetTypesPascalCaseSingular.GenericFile;
